<template>
  <div>
    <h3>
      Bounds for <span class="primary--text">{{ tune.title }}</span>
    </h3>
    <v-row v-if="position">
      <v-col cols="6" md="3" max-width="120px">
        <v-text-field
          label="Start"
          append-icon="mdi-timer-sand"
          type="number"
          hide-spin-buttons
          max-width="120"
          @click:append="setStartToCusor"
          v-model="position.start"
        ></v-text-field>
      </v-col>      
      <v-col cols="6" md="3">
        <v-text-field
          label="End"
          append-icon="mdi-timer-sand"
          type="number"
          hide-spin-buttons
          max-width="120"
          @click:append="setEndToCusor"
          v-model="position.end"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-btn
          small
          block
          v-if="saveConditions"
          @click="savePosition"
          color="info">
          <v-icon>mdi-content-save</v-icon> Save
        </v-btn>
      </v-col>
      <v-col cols="12" md="3">
        <v-btn
          small
          block
          v-if="isDirty"
          outlined
          @click="undo"
          color="warning">
          <v-icon>mdi-undo-variant</v-icon> Undo
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {

name: 'TunePosition',
components: {
},
data: function () {
  return {
    position: { ...this.tune.position },
    isDirty: false,
  }
},
mounted() {
},
methods: {
  setStartToCusor() {
    this.$emit('fetch-start');
  },
  setEndToCusor() {
    this.$emit('fetch-end');
  },
  savePosition() {
    this.$store.dispatch('tune/updatePosition',
      {
        start: this.position.start,
        end: this.position.end,
        id: this.position.id,
      }
    );
  },
  undo() {
    this.position = { ...this.tune.position };
    this.$nextTick(() => {
      this.isDirty = false;
    })
  }
},
props: {
  tune: {type: Object}
},
  computed: {
    saveConditions() {
      return this.isDirty && this.position.start!=null && this.position.end!=null;
  }
},
watch: {
  position: {
    handler() {
      this.isDirty = true;
    },
    deep: true,
  }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
